import React, { useState } from 'react'
import { ActivityTypeProvider } from './Hooks/ActivityTypeContext.js'
import LoginForm from './Modules/LoginForm.jsx'
import ChallengeChoice from './Modules/ChallengeChoice.jsx'
import ChallengeQuestion from './Modules/ChallengeQuestion.jsx'
import ChangePassword from './Modules/ChangePassword.jsx'
import OneTimePasscode from './Modules/OneTimePasscode.jsx'
import DSTAccess from './Static/DSTAccess.jsx'
import {
  CHANGE_PASSWORD_SUCCESS,
  FORM_NAME_CHALLENGE_CHOICE,
  FORM_NAME_CHALLENGE_QUESTION,
  FORM_NAME_CHANGE_PASSWORD,
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
  MFA_ANSWERED,
  PASSWORD_MODE,
} from './Helpers/LoginHelper.js'
import { useLoginInputHook } from './Hooks/LoginInputHook.js'
import { usePasswordInputHook } from './Hooks/PasswordInputHook.js'

function Login({ tmx_id }) {
  const loginInputHook = useLoginInputHook()
  const passwordInputHook = usePasswordInputHook()
  const [displayForm, setDisplayForm] = useState(FORM_NAME_LOGIN_FORM)
  const [mfaData, setMfaData] = useState(null)
  const [otpDta, setOtpData] = useState(null)
  const [challengeQuestionData, setChallengeQuestionData] = useState(null)
  const [loginState, setLoginState] = useState(null)
  const [changePasswordData, setChangePasswordData] = useState(null)

  const handleDisplayChange = (display, data) => {
    if (display === FORM_NAME_LOGIN_FORM) {
      setDisplayForm(display)
    }

    if (display === FORM_NAME_CHALLENGE_CHOICE) {
      setDisplayForm(display)
      if (data) {
        setMfaData(data)
      }
    }

    if (display === FORM_NAME_ONE_TIME_PASSCODE) {
      setDisplayForm(display)
      setOtpData(data)
    }

    if (display === FORM_NAME_CHALLENGE_QUESTION) {
      setDisplayForm(display)
      setChallengeQuestionData(data)
    }

    if (display === MFA_ANSWERED) {
      setDisplayForm(FORM_NAME_LOGIN_FORM)
      setLoginState(data)
    }

    if (display === FORM_NAME_CHANGE_PASSWORD) {
      setDisplayForm(FORM_NAME_CHANGE_PASSWORD)
      setChangePasswordData(data)
    }

    if (display === CHANGE_PASSWORD_SUCCESS) {
      setDisplayForm(FORM_NAME_LOGIN_FORM)
      setLoginState(data)
    }
  }

  return (
    <ActivityTypeProvider>
      <div className="u-sizeConstrained">
        <div className="u-marginTop10gu u-marginBottom4gu">
          <h2 className="u-paddingBottom2gu u-borderBottom u-inlineBlock u-borderBottomColorBrandLighter">
            Log in: Financial professionals
          </h2>
        </div>
      </div>
      <div className="u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
        <div className="u-sizeConstrained">
          {displayForm === FORM_NAME_LOGIN_FORM && (
            <LoginForm
              handleDisplayChange={handleDisplayChange}
              loginInputHook={loginInputHook}
              usePasswordInputHook={passwordInputHook}
              loginState={loginState}
              tmx_id={tmx_id}
            />
          )}

          {/*
        Login.hideContent();
        $(".challenge-choice-content").removeClass("hide").show();
      */}
          {displayForm === FORM_NAME_CHALLENGE_CHOICE && (
            <ChallengeChoice
              handleDisplayChange={handleDisplayChange}
              mfaResponseData={mfaData}
            />
          )}

          {/*
      Login.hideContent();
        $(".challenge-question-content").removeClass("hide").show()
      */}
          {displayForm === FORM_NAME_CHALLENGE_QUESTION && (
            <ChallengeQuestion
              handleDisplayChange={handleDisplayChange}
              challengeQuestionData={challengeQuestionData}
            />
          )}

          {/*
        Login.hideContent();
        $(".one-time-passcode-content").removeClass("hide").show();
        */}
          {displayForm === FORM_NAME_ONE_TIME_PASSCODE && (
            <OneTimePasscode
              handleDisplayChange={handleDisplayChange}
              otpDta={otpDta}
              loginInputHook={loginInputHook}
            />
          )}

          {/*
      Login.hideContent();
      $(".change-password-content").removeClass("hide").show();
      */}
          {displayForm === FORM_NAME_CHANGE_PASSWORD && (
            <ChangePassword
              handleDisplayChange={handleDisplayChange}
              changePasswordData={changePasswordData}
              passwordMode={PASSWORD_MODE.TEMP_PASSWORD}
              loginInputHook={loginInputHook}
            />
          )}
        </div>
      </div>
      {/*
        $(".login-content").hide()
        $(".security-questions-content").removeClass("hide").show();
        */}
      {/* <SecurityQuestions /> */}
      <DSTAccess />
    </ActivityTypeProvider>
  )
}

Login.propTypes = {}

export default Login
